import { useUnmount } from 'ahooks';
import isBrowser from 'ahooks/lib/utils/isBrowser';
import { useEffect, useRef } from 'react';

export interface Options {
  restoreOnUnmount?: boolean;
}

const DEFAULT_OPTIONS: Options = {
  restoreOnUnmount: false,
};

function useDocumentTitle(title: string, options: Options = DEFAULT_OPTIONS) {
  const titleRef = useRef(isBrowser ? document.title : 'ㅤㅤ');
  useEffect(() => {
    document.title = title || 'ㅤㅤ';
  }, [title]);

  useUnmount(() => {
    if (options.restoreOnUnmount) {
      document.title = titleRef.current;
    }
  });
}

export default useDocumentTitle;
